import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormFields } from '../../AccountForm.meta';
import { Checkbox } from '../../../../../../../../CommonComponents/OPL/Checkbox/Checkbox';
import { useAccountFormContext } from '../../context/useAccountFormContext';

export const IsSpouseSingleBeneficiary = () => {
  const {
    options: { HasSpouse: hasSpouse },
  } = useAccountFormContext();

  if (!hasSpouse) {
    return null;
  }

  const formBag = useFormContext<FormFields>();

  return (
    <Checkbox {...formBag.register('bankAccount.IsSpouseSoleBeneficiary')}>
      Spouse is sole beneficiary for this account
    </Checkbox>
  );
};
